var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChartSimple = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3C15 2.17157 14.3284 1.5 13.5 1.5H10.5C9.67157 1.5 9 2.17157 9 3V21C9 21.8284 9.67157 22.5 10.5 22.5H13.5C14.3284 22.5 15 21.8284 15 21V3ZM13.5 3.3C13.5 3.13431 13.3657 3 13.2 3H10.8C10.6343 3 10.5 3.13431 10.5 3.3V20.7C10.5 20.8657 10.6343 21 10.8 21H13.2C13.3657 21 13.5 20.8657 13.5 20.7V3.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 12C7.5 11.1716 6.82843 10.5 6 10.5H3C2.17157 10.5 1.5 11.1716 1.5 12V21C1.5 21.8284 2.17157 22.5 3 22.5H6C6.82843 22.5 7.5 21.8284 7.5 21V12ZM6 12.3C6 12.1343 5.86569 12 5.7 12H3.3C3.13431 12 3 12.1343 3 12.3V20.7C3 20.8657 3.13431 21 3.3 21H5.7C5.86569 21 6 20.8657 6 20.7V12.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 6C22.5 5.17157 21.8284 4.5 21 4.5H18C17.1716 4.5 16.5 5.17157 16.5 6V21C16.5 21.8284 17.1716 22.5 18 22.5H21C21.8284 22.5 22.5 21.8284 22.5 21V6ZM21 6.3C21 6.13431 20.8657 6 20.7 6H18.3C18.1343 6 18 6.13432 18 6.3V20.7C18 20.8657 18.1343 21 18.3 21H20.7C20.8657 21 21 20.8657 21 20.7V6.3Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChartSimple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chart-simple.0f4b27e13f83b072bc6c4358b3a7cc11.svg";